import http from '@/libs/axios'

export function getTransactions(params) {
  return http({
    url: '/finance/transaction/',
    method: 'GET',
    params,
  })
}
export function getTransactionIncomeType(query) {
  return http({
    url: '/finance/cost-item/',
    method: 'GET',
    params: query,
  })
}
export function getTransactionCashbox(query) {
  return http({
    url: '/finance/cashbox/',
    method: 'GET',
    params: query,
  })
}
export function addNewTransaction(data) {
  return http({
    url: '/finance/transaction/',
    method: 'POST',
    data,
  })
}

export function updateTransaction(data) {
  return http({
    url: `/finance/transaction/${data.id}/`,
    method: 'PATCH',
    data,
  })
}

// charts
export function getTransactionIncomeCharts(params) {
  return http({
    url: '/finance/transaction/income_statistic2/',
    method: 'GET',
    params,
  })
}

export function uploadFile(data) {
  console.log('data', data)
  return http({
    url: '/finance/transaction/import_transaction/',
    method: 'POST',
    data,
    responseType: 'blob',
  })
}

export function exportExcel() {
  return http({
    url: '/finance/transaction/export_transaction/',
    method: 'POST',
    responseType: 'blob',
  })
}
